import React from 'react';

import { css, merge } from 'glamor';

export default (props = {}) => (
  <svg { ...merge(css({display: 'block', width: props.width || 38, height: props.height || 55 }), {...props}) } xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56">
    <path fill="#FFF" fillRule="evenodd" d="M42.252 18.598L55.3 26.354a1.995 1.995 0 0 1-.01 3.533l-44.227 25.97a1.993 1.993 0 0 1-2.607-1.148l33.796-36.111zM11.217.148L33.36 13.311 8.365 40.02l.104-38.032a1.994 1.994 0 0 1 2.748-1.84zm32.54 7.045a1.729 1.729 0 0 1 2.527 2.36L2.993 55.45a1.729 1.729 0 0 1-2.53-2.357l43.292-45.9z"/>
  </svg>
);



// WEBPACK FOOTER //
// ../src/client/components/icons/VideoBroken.js